import i18next from "i18next";
import {initReactI18next} from "react-i18next";
import HttpApi from "i18next-http-backend";
// locale
import axiosInstance from "../axios";
import {LANGUAGE} from "../constants/language.constants";
import {getStorage} from "../helpers/storage";

const SUPPORTED_LANGUAGES = ["en", "sv", "fi"];
const query = new URLSearchParams(window.location.search);
// same order as the language switcher, so it does not switch (and fetch again) right after start
const language = query.get("language") || getStorage(LANGUAGE) || "sv";

const TRANSLATE = i18next;

i18next
  .use(initReactI18next)
  .use(HttpApi)
  .init({
    lng: language,
    fallbackLng: "sv",
    interpolation: {
      escapeValue: false,
    },
    supportedLngs: SUPPORTED_LANGUAGES,
    // only the current language (and the fallback) is fetched; others load on switch
    load: "currentOnly",
    react: {
      useSuspense: true,
    },
    backend: {
      loadPath: `locales/{{lng}}`,
      parse: (data) => {
        return data;
      },
      request: (options, url, payload, callback) => {
        axiosInstance
          .get(url)
          .then((res) => {
            callback(null, res);
          })
          .catch((err) => {
            callback(err, null);
          });
      },
    },
  });

export default TRANSLATE;
